:host {
  display: block;
}

.invalid .link-title {
  color: rgb(191, 38, 38);
}

.link-title {
  color: rgb(66 66 66)
}
.icon {
  position: absolute;
  right: 6%;
  top: 28%;
}

.invalid-link {
  cursor: not-allowed;
}